import { useEffect, useRef, useState } from 'react';
import { makeStyles, useMediaQuery, useTheme, } from "@material-ui/core";
import { Helmet } from "react-helmet";
import AnalysisFilterRealPanel from "./completed/filterPanel";
import AnalysisHeader from "./completed/subHeader";
import { useDispatch, useSelector } from "react-redux";
import UpcomingSection from './upcoming';
import LiveSection from './live';
import NoParticipants from './live/noparticipants';
import { BackDropAnalyzeLoading } from '../../../../atoms/commonLoadings';
import CompletedSection from './completed';
import { fetchSessionMarker } from "../../../../../store/actions/creator/analysis";
import { updateUserMetricsValue } from '../../../../../store/actions/auth/auth';
import AnalyzeMobileSection from '../../../../atoms/creator/analyzeMobileSection';
import UtilService from '../../../../../helper/service';
import AnalyzeLiveMemoSection from '../../../../atoms/creator/analyzeLiveMemoSection';
import { isMobile } from 'react-device-detect';

const useStyles = makeStyles(() => ({
  root: {
    flex: '1 1 auto',
    height: '100%',
    overflowX: 'hidden',
    background: '#F0F0F0',
    paddingTop: "37px"
  },
  loadingDiv: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%'
  },
  fullWidth: {
    flex: 1,
    width: '100%',
    display: 'flex',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    // height: '100%'
  },
}));

function LiveAnalysis() {

  const classes = useStyles();
  const dispatch = useDispatch();
  const scrollRef: any = useRef();

  const theme = useTheme();
  const isMobileWidth = useMediaQuery(theme.breakpoints.down('xs'));
  const isMobileDevice = isMobile && isMobileWidth;
  const [updateUserMetrics, setUpdateUserMetrics] = useState(false);
  const { filter } = useSelector((state: any) => state.creatorExperienceManager);
  const { currentSession, loading, settings, fullLoadedAnalysis, markersLoaded, all, isLoadedIdentifiers, immersion_overall, cliped, attendedIdentifiers, excludedParticipants, fingerpulseIdentifiers, fingerpulse } = useSelector((state: any) => state.analysis);
  const { clip, pdfLoading, clipLoading, mqttStatus } = settings;
  const { scheduled_start_at, session_status, session_type, session_code, braintrust_id, quicktest } = currentSession;
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : ""
  const attendedIds = session_type === 'MODERATED' ? attendedIdentifiers : attendedIdentifiers;
  const isModLive = session_type === 'MODERATED' && session_status === 'LIVE';

  const asyncLiveCheck = (session_type === 'ASYNC' && session_status === 'LIVE' && loading === 'backgroundLoading') ? false : loading;
  const customLoading =
    // !pdfLoading ||
    (asyncLiveCheck && !(session_status === 'LIVE' && fullLoadedAnalysis && session_type === 'MODERATED')) ||
    (!fullLoadedAnalysis && session_status !== 'UPCOMING' && attendedIds.length !== 0) ||
    !isLoadedIdentifiers ||
    mqttStatus === 'LIVE' && session_type === 'MODERATED' ||
    mqttStatus === 'COMPLETED' && !isLoadedIdentifiers ||
    clipLoading

  const availableImmersionClipedData = all.map((item: any) => item.immersion.data.filter((x: any) => UtilService.getLocalEpoch2(x.time_stamp) >= cliped?.start_clip && UtilService.getLocalEpoch2(x.time_stamp) <= cliped?.end_clip));
  const availbleClipedCounts = availableImmersionClipedData.filter((item: any) => item.length > 0);

  useEffect(() => {
    (session_code) && dispatch(fetchSessionMarker(apolloClient.client, { session_code }));
  }, [session_code, markersLoaded]);

  useEffect(() => {
    if (session_status && (session_status === 'COMPLETED' || session_status === 'LIVE') && !braintrust_id && !quicktest && (immersion_overall?.immersion_index > 1)) {
      if (!updateUserMetrics) {
        setUpdateUserMetrics(true)
      }
    }
  }, [session_status, immersion_overall]);

  useEffect(() => {
    if (updateUserMetrics) {
      dispatch(updateUserMetricsValue(apolloClient.client, { user_id: loginUserData.user_id, metrics_type: "EXPERIENCEANALYSIS" }))
      dispatch(updateUserMetricsValue(apolloClient.client, { user_id: loginUserData.user_id, metrics_type: "EXPERIENCESWITHDATA", metrics_value: session_code }))
    }
  }, [updateUserMetrics])

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = 0;
    }
  }, [pdfLoading])

  const onNoteScroll = (e: number) => {
    const divHorScroll = document.getElementById("live_scroll");
    const scrollHeight = window.innerHeight ? window.innerHeight - 220 : 600
    if (!divHorScroll) return;
    divHorScroll.scrollTo({
      top: e - scrollHeight,
      behavior: "smooth",
    });
  }

  if (!currentSession) {
    return <></>
  }

  return (
    <div
      className={classes.root}
      style={{ paddingTop: 37 }}
      id={"live_scroll"}
      ref={scrollRef}
    >
      <Helmet title="Analysis" />

      <BackDropAnalyzeLoading loading={pdfLoading} />

      {session_status === 'UPCOMING' && <UpcomingSection startTime={scheduled_start_at} />}

      {session_status !== 'UPCOMING' && !isMobileDevice && (
        <div className={classes.container} ref={scrollRef} id='analyze' style={{ background: '#f0f0f0' }}>
          {session_status && <AnalysisHeader />}
          <div className={classes.fullWidth} >
            {filter && attendedIds?.length > 0 && !clip && <AnalysisFilterRealPanel />}

            {(session_status === 'COMPLETED' || (session_type === 'ASYNC' && attendedIds?.length > 0)) &&
              ((all.length === 0) ?
                attendedIds?.length === 0 ?
                  <NoParticipants
                    title='Hmmm. Our records show that no one participated in this Experience.'
                    img={'/assets/icons/liveanalysis/QA_engineers.svg'}
                    nonCompleted={true}
                  /> :
                  fullLoadedAnalysis ?
                    ((attendedIdentifiers.length === excludedParticipants?.length) ?
                      <NoParticipants
                        title='Shoot…it looks like we were unable to get clean data from your participants.'
                        excluded
                        img={'/assets/icons/liveanalysis/QA_switches.svg'}
                      /> : <NoParticipants
                        title='There is no data to display as all participant groups are toggled off.'
                        description='To view participant data, toggle on “All Participants,” “Tags,” or individual participants on the left hand panel.'
                        img={'/assets/icons/liveanalysis/QA_switches.svg'}
                      />)
                    :
                    <NoParticipants
                      title='We’re loading your results'
                      description='Sometimes neuroscience can take a bit of time, so we really appreciate your patience'
                      img={'/assets/icons/liveanalysis/async-no-participants.svg'}
                    />
                : (
                  (cliped && availbleClipedCounts.length > 0 || !cliped) ?
                    ((fingerpulse && fingerpulseIdentifiers.length === attendedIdentifiers.length) 
                    ? <NoParticipants
                      title={'Shoot.. it looks like everyone measured used finger pulse.'}
                      description="If you want to look at individual participants you can always toggle on device ID code in the left panel. Otherwise, toggle off exclude finger pulse to see all participants' data again."
                      img={'/assets/icons/liveanalysis/QA_switches.svg'}
                    /> : <CompletedSection />) :
                    <NoParticipants
                      title={'Humm… Looks like there is no data for this clip.'}
                      description='To view participant data, please select another clip range.'
                      img={'/assets/icons/liveanalysis/QA_engineers.svg'}
                    />
                ))
            }

            {
              (session_status === 'LIVE' && session_type === 'MODERATED') &&
              ((attendedIds?.length > 0 && all.length > 0)
                ? <LiveSection onNoteScroll={onNoteScroll} />
                : ((immersion_overall?.immersion_index)
                  ? <NoParticipants
                    title={fullLoadedAnalysis ? 'There is no data to display as all participant groups are toggled off.' : 'We’re loading your results'}
                    description={fullLoadedAnalysis ? 'To view participant data, toggle on “All Participants,” “Tags,” or individual participants on the left hand panel.' : 'Sometimes neuroscience can take a bit of time, so we really appreciate your patience'}
                    img={fullLoadedAnalysis ? '/assets/icons/liveanalysis/QA_switches.svg' : '/assets/icons/liveanalysis/async-no-participants.svg'}
                    link={true}
                  />
                  : <NoParticipants
                    title={fullLoadedAnalysis ? 'We’re still waiting for your first participants to complete their measurement.' : 'We’re still waiting for your first participant to join your experience.'}
                    description={'We’ll show you results as soon as they start coming in.'}
                    img={'/assets/icons/liveanalysis/async-no-participants.svg'}
                    link={true}
                  />
                ))
            }

            {
              session_status === 'LIVE' && attendedIds?.length === 0 && session_type === 'ASYNC' &&
              <NoParticipants
                title={'We’re still waiting for your first participants to complete their measurement.'}
                description={'We’ll show you results as soon as they start coming in.'}
                img={'/assets/icons/liveanalysis/async-no-participants.svg'}
                link={true}
              />
            }

            {
              loading === 'liveToCompleted' &&
              <NoParticipants
                title={'The session has just completed.'}
                description={'It will take some time to calculate data collection, so please wait for a while...'}
                img={'/assets/icons/liveanalysis/async-no-participants.svg'}
              />
            }

          </div>
        </div>
      )}

      <BackDropAnalyzeLoading loading={customLoading} />

      {
        isMobileDevice && session_status && !isModLive && session_status !== 'UPCOMING' && <AnalyzeMobileSection />
      }

      {
        isMobileDevice && session_status && isModLive && <AnalyzeLiveMemoSection />
      }

    </div>
  );
}

export default LiveAnalysis;